import React from 'react';
import LoggedInPage from '../../views/core/LoggedInPage';
import topicinfoIcon from './images/testinfo.png';
import alertIcon from './images/alert.png';
import heymathIcon from '../../images/icons/heypractest_icon.png';
import HmAjax from '../../util/HmAjax';
import Loader from 'react-loader-spinner';
import HmEventRegistry from '../../model/HmEventRegistry';
import ComponentRegistry from '../../model/ComponentRegistry';

export default class ms_TestInfo extends LoggedInPage {
	constructor(props) {
		super(props);
		this.state = {			
			testInfoLoaded:false,
			topicInfoObj:[]
		};

		this.startTest = this.startTest.bind(this);
		this.trackTestStart = this.trackTestStart.bind(this);
		this.trackTestClose = this.trackTestClose.bind(this);
		this.testId = this.props.testId;
		this.classId = this.props.classId;


		this.timedTest = false;	
	}

	startTest(){	
		this.props.callbackParent(this.state.topicInfoObj,this.props.topicsubtopicId,this.props.revisiontestid);
	}
	componentWillMount(){
		this.props.onRef(undefined);
	}
	componentDidMount = () => {
		this.props.onRef(this);
		this.testId = this.props.testId;
		this.classId = this.props.classId;

		if(this.props.testId == 0 || this.props.testId == "0"){				
			var me = this;
			var callBackSuccess = function(response){
				
				if(response.code === 200){
					me.loadTestInfo(response.data);
				}else if(response.code === 403 && response.message=="TEST_LOCKED"){
					me.showAlert(' ',me.rb("test.locked"));
				}else{
					alert("GET_TEST_ID Error:: "+me.rb("error.oops"));
				}
				
			}

			var callBackFailure = function(response){
				alert("GET_TEST_ID Error : ", response);				
			}
			
			if(this.props.accessId !== undefined  && this.props.accessId !== null && this.props.accessId > 0){
				new HmAjax(this.getUrlFor("GET_TEST_ID")+"?access="+this.props.accessId+"&revisionTestId="+this.props.revisiontestid+"&topicsubtopicId="+this.props.topicsubtopicId+"&classId="+this.classId).get(callBackSuccess,callBackFailure);
			}

		}else{
			this.loadTestInfo(this.props.testId);
		}

		HmEventRegistry.fireEvent("INITIATE_GA_EVENT");  
	}
	loadTestInfo(testId){
		this.testId = testId;
		var me = this;
		var callBackSuccess = function(response){		
			console.log(JSON.parse(response.data));
			if(response.code === 200){
				me.setState({testInfoLoaded:true,topicInfoObj:JSON.parse(response.data)});
				me.trackTestStart();
			}else if(response.code === 403 && response.message=="TEST_LOCKED"){
				me.showAlert(' ',me.rb("test.locked"));
			}else{
				alert("GET_TEST_INFO Error:: "+me.rb("error.oops"));
			}
		}

		var callBackFailure = function(response){
			alert("GET_TEST_INFO Error : ", response);			
		}

		new HmAjax(this.getUrlFor("GET_TEST_INFO")+testId).put(callBackSuccess,callBackFailure);		
		
	}
	trackTestStart(){
		var postParams = {
			trackingDefId: 4,
			testId : this.testId,
			startTime : new Date().getTime(),
			action : this.state.topicInfoObj.userTest.status
		}
		
		var me = this;
		var callBackSuccess = function(response){
		}

		var callBackFailure = function(error){
			console.log("Error in TRACK_SOLUTION");
		}

		new HmAjax(this.getUrlFor("TRACK_SOLUTION"),postParams).post(callBackSuccess,callBackFailure);
	}
	trackTestClose(){
		try{
			var postParams = {
				"trackingDefId" : 4,
				"testId" : this.testId,
				"endTime" : new Date().getTime()				
			}

			var me = this;
			var callBackSuccess = function(response){
			}

			var callBackFailure = function(error){
				console.log("Error in TRACK_TEST_CLOSED");
			}

			new HmAjax(this.getUrlFor("TRACK_TEST_CLOSED"),postParams).post(callBackSuccess,callBackFailure);
		}catch(e){}
	}
	getStatusText(){
		if(this.state.testInfoLoaded){
			if(this.state.topicInfoObj.userTest.status == "IN_PROGRESS"){
				return this.rb("home.continue");
			}else{
				return this.rb("home.start");
			}
		}
		else{
			return this.rb("home.start");
		}
	}
	getTopicName(){
		var topicname = this.state.topicInfoObj.testDetails.topics;
		topicname = topicname.split("- Customized Practice").join("");		  
		return (topicname);
	}
	getMinutesStr(){
		var secsTime = this.state.topicInfoObj.testDetails.durationInSeconds;

		if(secsTime > 0){
			this.timedTest = true;
			var minutes = Math.floor(secsTime / 60);
			minutes = minutes + " Minutes";
			return (minutes);	
		}else{
			this.timedTest = false;
		}

		return 0;
	}
	renderTestInfo(){
		if (this.state.testInfoLoaded === false) {
			return(
				<div className="text-center loadingAnim">
				<Loader 
				type="Oval"
				color="#00BFFF"
				height="100"	
				width="100"
				/>
				</div>
				)
			}else{
				return(
				<div className="row modalBase">
				<div className="col-md-4 text-center leftPanel">

				<div className="topicDetails">
				<div className="title">{this.state.topicInfoObj.testDetails.title}</div>
				<div className="topicName">{this.getTopicName()}</div>
				</div> 

				<span className="iconDiv">

				{( () => {
					if(this.state.topicInfoObj.testDetails.mode == 1 || this.state.topicInfoObj.testDetails.mode == "1"){
						return <img src={topicinfoIcon} />
					}else{
						return <img src={heymathIcon} />
					}
				}) ()}
				</span>

				</div>
				<div className="col-md-8 rightPanel">
				<div className="testInfo">
				<div className="row">
				<div className="col-md-9 col-9 caption">{this.rb("testinfo.totalquestions")}</div>
				<div className="col-md-3 col-3 nopadding bigNumbers text-right">{this.state.topicInfoObj.testDetails.questionTypeCount}</div>
				</div>

				{(() => {
					if(this.getMinutesStr() && this.getMinutesStr().length > 0){
						return (

				<div className="row totalDuration">
				<div className="col-md-6 col-6 caption">{this.rb("testinfo.duration")}</div>
				<div className="col-md-6 col-6 nopadding bigNumbers text-right">{this.getMinutesStr()}</div>
				</div>
						)
					}

				})()}


				<div className="float-right bottomBtns">
				<button type="button" className="btn btn-primary largeBtn" onClick={this.startTest}  data-ga={"Post login - "+this.props.gradeName+" - Tests - "+this.state.topicInfoObj.testDetails.title+" - "+this.getTopicName()+" - PT - "+this.getStatusText()}>
				{this.getStatusText()}
				</button>
				</div>
				<div className="instruct">
				<span><img src={alertIcon} /></span>
				{( () => {
					let dynInstruct = this.state.topicInfoObj.testDetails.instructions || this.rb("testinfo.instruction")
						return (
							<span>{dynInstruct}</span>
						)
				}) ()}
				
				</div>

				</div>						
				</div>					

				</div>
				)
			}

		}
		render = () => {
			return(				
			<div>
			{this.renderTestInfo()}
			</div>
			);
		}
	}


ComponentRegistry.register("ms_TestInfo",ms_TestInfo);

/*
* Also registering for the users with hm_ prefix
*/
ComponentRegistry.register("hm_TestInfo",ms_TestInfo);


// WEBPACK FOOTER //
// ./src/vendors/mindstretcher/ms_TestInfo.js